import { useContext } from 'react'
import InputContext from './InputContext'

const useInputContext = () => {
    return useContext(InputContext)
}

export default useInputContext
